import { IsNotEmpty, IsNumber } from "class-validator";

import { IEventAddOn } from "./event-add-on.interface";

export class EventAddOnDto implements IEventAddOn {
  @IsNotEmpty()
  add_on_id: string;

  @IsNumber()
  quantity: number;
}
